import React, { createContext, useReducer } from 'react';
import axios from '../../axios';

const initialValue = {
    categories: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_DASHBOARD_DATA': {
            return {
                ...state,
                category_list: action.payload,
            }
        }
        default: {
            return state
        }
    }
}

const UploadImageContext = createContext({
    uploadImage: () => {},
})

export const UploadImageProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)

    const uploadImage = async (data) => {
        try {
            const options = {
                headers : {'Content-Type': 'multipart/form-data'}
            }

            const res = await axios.post('/api/upload_product_image', data, options);

            return res.data;
        } catch (e) {
            return null;
        }
    }

    return (
        <UploadImageContext.Provider
            value={{
                uploadImage,
                state, 
                dispatch
            }}
        >
            {children}
        </UploadImageContext.Provider>
    )
}

export default UploadImageContext
